import React from "react";
import FormTemplate from "@/components/templates/FormTemplate";
import AccountCreationForm from "@/components/organisms/AccountCreationForm";

function CreateAccount() {
  return (
    <FormTemplate title="Create AWS Account">
      <AccountCreationForm />
    </FormTemplate>
  );
}

export default CreateAccount;
